module.exports = __webpack_public_path__ + "img/11be5d1.png";